import styled from "styled-components"

const TitleContent = styled.p`
  color: #8ad2ff;
  font-family: "din-condensed";
  font-size: 24px;
  font-weight: 400;
  pointer-events: none;
`

export default TitleContent



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/TitleContent.js